import { render } from "./SubWizard.vue?vue&type=template&id=2b8fa649&scoped=true"
import script from "./SubWizard.vue?vue&type=script&lang=js"
export * from "./SubWizard.vue?vue&type=script&lang=js"

import "./SubWizard.vue?vue&type=style&index=0&id=2b8fa649&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b8fa649"]])

export default __exports__